import { FormControlValidator } from '../use-form-control';
import { RegexValidator } from './regex';

export const EmojiValidator = (customMsg?: string): FormControlValidator =>
  RegexValidator(/^(?!.*\p{Extended_Pictographic})/u, customMsg || "Emoji's are not allowed.");
